import type { IHomepageMetricGroup } from '@skystone/shared';
import { Link } from 'react-router-dom';
import { Badge, Card, CardContent } from '@/components/ui';
import { ChevronRightIcon } from '@/components/ui/icons';

interface MetricGroupCardProps {
  group: IHomepageMetricGroup;
}

export function MetricGroupCard({ group }: Readonly<MetricGroupCardProps>) {
  return (
    <Card className="flex h-full flex-col">
      <CardContent className="flex flex-1 flex-col gap-3 pt-6">
        <div className="flex items-start justify-between gap-3">
          <div className="space-y-1">
            <div className="flex flex-wrap items-center gap-2">
              <h3 className="text-sm font-semibold uppercase tracking-wider text-foreground">
                {group.title}
              </h3>
              {group.isNew && <Badge variant="success">NEW</Badge>}
            </div>
            <p className="text-sm italic text-muted-foreground">{group.subtitle}</p>
          </div>
          {group.sourceBadge && (
            <Badge variant="default" className="shrink-0">
              {group.sourceBadge}
            </Badge>
          )}
        </div>
        {group.metricListPreview && (
          <p className="text-sm text-muted-foreground">{group.metricListPreview}</p>
        )}
        {group.linkTarget && (
          <div className="mt-auto pt-2">
            <Link
              to={group.linkTarget}
              className="inline-flex items-center gap-1 text-sm font-medium text-primary hover:underline"
            >
              Explore metrics
              <ChevronRightIcon className="h-4 w-4" />
            </Link>
          </div>
        )}
      </CardContent>
    </Card>
  );
}
